<template>
  <el-container direction='vertical'>
    <div class="credit-container">
      <img :src="banner">
    </div>
    <div class="user-container">
      <div class="head-img"><img :src="userInfo.wxheadurl" alt=""></div>
      <div v-if="userInfo.name!==''" class="head-name">{{userInfo.name}}</div>
      <div v-else class="head-name">{{userInfo.wxname}}</div>
      <div class="head-id">会员ID：<span>{{userInfo.mid}}</span></div>
    </div>
    <div class="exchange-record">
      <div class="head-id">可用积分：<span>{{credit}}</span></div>
      <div class="exchange-btn" @click="handleExchange">兑换记录</div>
    </div>
    <el-container>
      <div class="goods-content">
       <div class="list" v-for="(item,i) in goodsList" :key="i" @click="handleJump(item.id)">
          <div class="img-content">
            <div class="ha-box" :style="{backgroundImage: 'url(' +item.coverimg + ')', backgroundSize:'cover'}"></div>
          </div>
          <div class="text-content">
            <div class="title">{{item.title}}</div>
            <div class="desc">
              <div class="t-left">销量{{item.exchanged}}</div>
              <div class="t-right"><span>{{item.needpoints}}</span>积分</div>
            </div>
          </div>
        </div>
        <p v-if="goodsList.length === 0" class="v-tip">暂无数据</p>
        <p v-if="isHasMore && goodsList.length !== 0" @click="onInfinite" class="v-more" ><nut-icon type="down" color="#848484"></nut-icon></p>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import { getUserInfo, getAvailable } from '@/views/mobile/MemberCenter/apis'
import { goodsListApi } from '@/views/mobile/GoodsList/apis'

export default {
  data () {
    return {
      banner: require('@/views/mobile/GoodsList//assets/images/banner.jpg'),
      userInfo: {},
      goodsList: [],
      page: 1,
      size: 10,
      pageAll: 0,
      isHasMore: false,
      credit: 0
    }
  },
  methods: {
    requestUserInfo () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          if (result) {
            this.userInfo = result.data
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
          }
        }).catch(error => {
          if (error) {}
        })
    },
    getCredit () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getAvailable(data)
        .then(result => {
          if (result) {
            this.credit = result.data.points
          }
        }).catch(error => {
          if (error) {}
        })
    },
    onInfinite () {
      this.page = this.page + 1
      this.getGoodsList()
    },
    getGoodsList () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('page', this.page)
      data.append('size', this.size)
      goodsListApi(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.goodsList = this.goodsList.concat(result.data.list)
            this.pageAll = result.data.pager.pages
            if (this.page < this.pageAll) {
              this.onInfinite()
              // this.isHasMore = true
            } else {
              this.isHasMore = false
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    handleJump (id) {
      this.$router.push({
        path: '/goodsDetails',
        query: {id}
      })
    },
    handleExchange () {
      this.$router.push({
        path: '/exchange'
      })
    }
  },
  mounted () {
    this.requestUserInfo()
    this.getCredit()
    this.getGoodsList()
    this.loading = this.$toast.loading()
  },
  created () {
  }
}
</script>
<style lang="less">
@import "./assets/css/index.less";
</style>



// WEBPACK FOOTER //
// src/views/mobile/GoodsList/index.vue